var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGridTwoActive = function SvgIconGridTwoActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.584 11.75H3.417c-1.25 0-1.75.533-1.75 1.858v3.367c0 1.325.5 1.858 1.75 1.858h13.167c1.25 0 1.75-.533 1.75-1.858v-3.367c0-1.325-.5-1.858-1.75-1.858M16.584 2.168H3.417c-1.25 0-1.75.533-1.75 1.858v3.367c0 1.325.5 1.858 1.75 1.858h13.167c1.25 0 1.75-.533 1.75-1.858V4.026c0-1.325-.5-1.858-1.75-1.858"
  })));
};
export default SvgIconGridTwoActive;